import { useState } from "react";
import { toast } from "sonner";
import { Flag } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";

const REASONS = ["Unmarked spoiler", "Spam", "Harassment or hate", "Piracy link", "Misinformation", "Other"];

export function ReportButton({ type, id, label = "Report", linkReport = false, className = "" }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState(linkReport ? "Broken link" : REASONS[0]);
  const [details, setDetails] = useState("");
  const reasons = linkReport ? ["Broken link", "No longer available", "Wrong region", "Wrong price/type", "Other"] : REASONS;

  const submit = async () => {
    try {
      if (linkReport) await api.post(`/links/${id}/report`, { reason: details ? `${reason}: ${details}` : reason });
      else await api.post("/reports", { target_type: type, target_id: id, reason, details });
      toast.success("Thanks — our moderators will review this.");
      setOpen(false);
    } catch (e) { toast.error(errMsg(e)); }
  };

  const onOpen = (v) => {
    if (v && !linkReport && !user) return nav(`/login?next=${encodeURIComponent(window.location.pathname)}`);
    setOpen(v);
  };

  return (
    <Dialog open={open} onOpenChange={onOpen}>
      <DialogTrigger asChild>
        <button data-testid={`report-${type}-${id}`} className={`inline-flex items-center gap-1 text-xs text-slate-500 hover:text-red-400 ${className}`}><Flag className="h-3.5 w-3.5" />{label}</button>
      </DialogTrigger>
      <DialogContent className="border-white/10 bg-[#12121A]">
        <DialogHeader><DialogTitle className="font-display text-2xl">{linkReport ? "Report this link" : `Report ${type}`}</DialogTitle></DialogHeader>
        <div className="flex flex-wrap gap-2">
          {reasons.map((r) => (
            <button key={r} onClick={() => setReason(r)} className={`rounded-full border px-3 py-1 text-xs ${reason === r ? "border-amber-400 bg-amber-400/10 text-amber-300" : "border-white/10 text-slate-400"}`}>{r}</button>
          ))}
        </div>
        <textarea data-testid="report-details" value={details} onChange={(e) => setDetails(e.target.value)} maxLength={500} placeholder="Optional details"
          className="min-h-[80px] w-full rounded-xl border border-white/10 bg-black/30 p-3 text-sm outline-none focus:border-amber-400" />
        <button data-testid="report-submit" onClick={submit} className="rounded-full bg-amber-400 px-5 py-2.5 text-sm font-bold text-black hover:bg-amber-300">Submit report</button>
      </DialogContent>
    </Dialog>
  );
}
